import { atom } from "jotai";
import EnhancedContentRecord from "models/view-models/enhanced-content-record";

const CurrentPublicationEnhancedContent = atom<EnhancedContentRecord[]>([]);

export default CurrentPublicationEnhancedContent;
